module.exports = {
    title: "Institutes",
    crud: {
        create: "Create Institute",
        edit: "Edit Institute",
        view: "View Institute",
        merge: "Merge Institute",
        other: "Other Institute",
    },
    table: {
        title: "Institutes",
        isDefault: "Is Default",
    },
    form: {
        title: "Title",
        newtitle: "New title",
        duplicate: "Move To Institute",
    },
    validation: {
        required: {
            title: 'Title is required',
        },
        minLength: {
            title: 'title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
